<!-- 

URL: /financeiro/financeirobaixas

-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import FilterList from '../components/filter-list'
import Filtro from '../consultas/filtro'
import Chart from './chart'
import { apiORDSpost, apiDownload2 } from '../shared/api-functions'

export default {
    components: {
        BarList, BarGrid, FilterList, Filtro, Chart
    },

    data () {
        return {
            dados: [],  
            grafico: null,
            tipo: 'R',
            tipoOptions: [{ id: 'R', text: "Recebido" }, { id: 'P', text: "Pago" }],
            periodo: { data_inicio: null, data_termino: null, startDate: null, endDate: null },
            titulos: null,
            filtro: {
                periodos: [{ data_inicio: null, data_termino: null }],
            }          
        }
    },

    computed: {
        paramsChart: function () {            
            if (!this.grafico)
                return null

            let grafico = []
            grafico.push(this.grafico.labels)

            for (var x = 0; x < this.grafico.dados.length; x++) {
                grafico.push([this.grafico.dados[x].descricao, this.grafico.dados[x].valor])
            }

            return { 
                chart: { type: 'PieChart' }, 
                values: grafico 
            }
        },
    },

    watch: {
        
    },

    methods: {
        loadData(excel) {
            let url = "consulta/vendas/pagamentosfinanceiro";

            this.periodo.data_inicio = this.periodo.startDate
            this.periodo.data_termino = this.periodo.endDate
            this.filtro.periodos = [ this.periodo ]
            this.filtro.tipo = this.tipo

            if (excel) 
                apiDownload2(this, url, this.filtro, "post")
            else {
                let self = this
                apiORDSpost(this.$store, url, this.filtro, "post").then((data) => {
                    console.log(data)
                    if (data) {
                        self.dados = data.dados
                        self.grafico = data.grafico
                    }
                })
            }

            this.changeTitle()
        },

        changeTitle() {
            if (this.tipo === 'P') {
                this.titulo = 'Pagamentos do período por natureza financeira'
            } else {
                this.titulo = 'Recebimentos do período por natureza financeira'
            }
        }
    },

    filters: {

    },

    created () {
        // this.filtro.periodos[0].data_inicio = this.$firstDay(this.$getDate())
        // this.filtro.periodos[0].data_termino = this.$lastDay(this.$getDate())

        this.periodo.data_inicio = this.$firstDay(this.$getDate())
        this.periodo.data_termino = this.$lastDay(this.$getDate())
        this.periodo.startDate = this.$firstDay(this.$getDate())
        this.periodo.endDate = this.$lastDay(this.$getDate())
        // this.loadData(false)
    }
}
</script>

<template>
    <div>
        <div class="default-container">
            <div class="row">
                <div class="col-12">
                    <span class="lbl-deal-title mb-2 w-100">
                        ANÁLISE DE PAGAMENTOS
                    </span>
                </div>
            </div>

            <hr />
            
            <!-- Filtro -->
            <div class="row">
                <div class="col-md-4">
                    <v-label label="Período"></v-label>
                    <input-month2 :p-month="periodo"></input-month2>
                </div>
                <div class="col-md-4">
                    <form-field v-model="tipo" type="select" label="Tipo de Fluxo"
                    :select-options="tipoOptions"></form-field>
                </div>
                <div class="col-md-4 d-flex align-items-center">
                    <v-button label="Filtrar" :success="true" @click="loadData"></v-button>
                </div>
            </div>
            
            <hr />

            <div class="row" v-if="dados.length > 0">
                <div class="col-12 d-flex justify-content-center">
                    <span class="lbl-deal-title title-upper mb-2">
                       {{ titulo }}
                    </span>
                </div>
            </div>

            <div class="row" v-if="dados.length == 0">
                <div class="col-12 d-flex justify-content-center">
                    <span class="lbl-deal-title title-upper mb-5 mt-5">
                       NÃO HÁ DADOS A SEREM EXIBIDOS
                    </span>
                </div>
            </div>
            
            <div class="row" v-if="dados.length > 0">
                <!-- Tabela -->
                <div class="data-table col-6 lbl-title">
                    <table class="table table-bordered table-sm responsive w-100 bg-light">
                        <thead>
                            <tr>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Natureza
                                </th>
                                <th colspan="1" class="numerico size100 textual text-center">
                                    Valor (R$)
                                </th>
                            </tr>
                        </thead>
                        <tbody>                    
                            <tr v-for="(dado, index) in dados" :key="index">
                                <th class="textual">
                                    <span :class="'lvl-' + dado.nivel">
                                        {{ dado.natureza }}
                                    </span>
                                </th>
                                <td class="numerico size100 text-center value-bg-color">
                                    <span>
                                        {{ dado.valor | formatValue(2) }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            
                        </tfoot>
                    </table>
                </div>
                <!-- Grafico -->
                <div class="grafico col-6 lbl-title" v-if="grafico">
                    <div class="border">
                        <chart :params="paramsChart"></chart>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<style scoped>

.text-navy-blue {
    color: #174b79 !important;
}

.text-blue {
    color: #2469a5 !important;
}

.total {
    padding: 0 .25rem;
}

.total p {
    color: #808080bb;
    text-align: end;
    font-size: .85rem;
    font-weight: bold;
    margin-bottom: -7.5px;
}

.total small {
    font-size: 1rem;
    font-weight: 500;
    padding-right: .25rem;
    color: #212529 !important;
}

.total span {
    font-size: 1.85rem;
    font-weight: bold;
    cursor: pointer;
}

.data-table {
    overflow: auto;
}

.data-table {
    overflow: auto;
}

table .textual {
    font-size: 12px;
    padding: 4.8px;
}

table .numerico {
    font-size: 12px;
    min-width: 65px;
    text-align: right;
}

table .size130 {
  min-width: 130px;
}

table .size100 {
  width: 100px;
}

table .total {
    background: #c1c4c7;
    border: none;
}

table .var {
    min-width: 85px;
    text-align: center;
    background: #c1c4c7;
    display: inline-block;
}

table .var-negative {
    color: white;
    background: indianred;
}

table .var-positive {
    color: white;
    background: green;
}

table .border-left {
  border-left: 1px solid #dee2e6;
}

.value-bg-color {
    background-color: #fafffa !important;
}

.consulta__total {
  display: flex;
  align-items: center;
  justify-content: center;
}

.consulta__total_valor {
  font-size: 40px;
  display: block;
  line-height: normal;
}

.consulta__cifrao {
  font-size: 16px;
  display: block;
  line-height: normal;
}

.lvl-1 {
    margin-left: .3rem;
}

.lvl-2 {
    margin-left: .3rem;
}

.lvl-3 {
    margin-left: 1.5rem;
}

.lvl-4 {
    margin-left: 2.5rem;
}

.title-upper {
    text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/consultas/consulta-financeiro-baixas.vue